import { JobSearchResult } from '../../types';

/**
 * Map a unified-search result to the route of its existing detail screen.
 *
 * pending/rejected detail screens are keyed by the opportunity id (`result.id`).
 * applied/archived detail screens are keyed by the *application* id, which the
 * backend supplies as `applicationId` (non-null for those two statuses).
 *
 * The `applicationId` guards are defensive: if an applied/archived result ever
 * arrives without one, we fall back to the bucket's list so the click still
 * lands the user in the right place rather than on a broken detail route.
 */
export function searchResultRoute(result: JobSearchResult): string {
  switch (result.status) {
    case 'pending':
      return `/opportunities/${result.id}`;
    case 'rejected':
      return `/opportunities/rejected/${result.id}`;
    case 'applied':
      return result.applicationId ? `/applications/${result.applicationId}` : '/applications';
    case 'archived':
      return result.applicationId ? `/archive/${result.applicationId}` : '/archive';
    default:
      return '/';
  }
}
